import { colors } from '../../colors';
var location = {
  bgColor: colors.palePurple,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black,
  cardRadius: '20px',
  backgroundWave: true
};
export default location;